'use strict';

exports.__esModule = true;
var sym = typeof Symbol === 'function' ? Symbol : function (id) {
  return '@@revalidate/' + id;
};

exports.default = sym;


//////////////////
// WEBPACK FOOTER
// ../validation/~/revalidate/lib/internal/sym.js
// module id = 583
// module chunks = 22